<rpe-page-template title="DATOS DE LA EMPRESA" route="/empresas/mis-empresas"> 
  <ng-container slot="content">
    <rpe-datos-mi-empresa-container [modificarButtons]="true" [matCard]="true"></rpe-datos-mi-empresa-container>
  </ng-container>
</rpe-page-template>  